import React from 'react';

type Props = {
    shown: boolean,
    view: React.ReactNode,
    children: React.ReactNode,
};

export const Skeleton = ({shown, view, children}: Props) => {
    if (!shown) {
        return <>{children}</>;
    }

    if (React.isValidElement(view)) {
        const props = view.props as Record<string, unknown>;
        const cloneProps: Record<string, unknown> = {};

        if (props.role === undefined) {
            cloneProps.role = 'skeleton';
        }

        if (props['data-skeleton'] === undefined) {
            cloneProps['data-skeleton'] = true;
        }

        return Object.keys(cloneProps).length > 0 ? React.cloneElement(view, cloneProps) : view;
    }

    return <>{view}</>;
};
